import { useTheme } from '@dhl-ui/components'
import { ExpandMoreIcon } from '@dhl-ui/icons'

type Props = {
  /**
   * Is our expandable menu open or not
   * @default false
   */
  isOpen?: boolean

  /**
   * Inverse of main menu variant (bottom)
   */
  inverse?: boolean
}

export const Facet = ({ isOpen, inverse }: Props) => {
  const { spacing } = useTheme()
  const rotation = inverse ? ['-90deg', '-270deg'] : ['0', '-180deg']
  const size = spacing(3)

  return (
    <ExpandMoreIcon
      sx={{
        transform: isOpen ? `rotate(${rotation[1]})` : `rotate(${rotation[0]})`,
        transition: '100ms ease-in-out',
        width: size,
        height: size,
      }}
    />
  )
}
